/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerGetPermissionsQueryResponse, UserControllerGetPermissionsPathParams, UserControllerGetPermissions401, UserControllerGetPermissions403 } from "../../models/usersController/UserControllerGetPermissions";

function getUserControllerGetPermissionsUrl(userId: UserControllerGetPermissionsPathParams["userId"]) {
  const res = { method: 'GET', url: `/api/v1/users/${userId}/permissions` as const }  
  return res
}

/**
 * @summary Get user scope permissions
 * {@link /api/v1/users/:userId/permissions}
 */
export async function userControllerGetPermissions(userId: UserControllerGetPermissionsPathParams["userId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UserControllerGetPermissionsQueryResponse, ResponseErrorConfig<UserControllerGetPermissions401 | UserControllerGetPermissions403>, unknown>({ method : "GET", url : getUserControllerGetPermissionsUrl(userId).url.toString(), ... requestConfig })  
  return res.data
}